import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export const LEGACY_SETUP_PATHS = ["/alpha", "/alpha/recommendation", "/alpha/brokerage", "/alpha/ibkr", "/alpha/ibkr/confirmation", "/alpha/questionnaire", "/alpha/review"] as const;

// Questionnaire remains a preference editor and must not be redirected away.
export const LEGACY_SETUP_REDIRECT_PATHS = LEGACY_SETUP_PATHS.filter(path => path !== "/alpha/questionnaire");

export default function AlphaSetupCompatibilityRedirect() {
  const location = useLocation();
  const pathname = location.pathname.replace(/\/+$/, "") || "/alpha";
  const brokerage = ["/alpha/brokerage", "/alpha/ibkr", "/alpha/ibkr/confirmation"].includes(pathname);
  return <Navigate replace to={{ pathname: brokerage ? "/alpha/setupv2/brokerage" : "/alpha/setupv2", search: location.search, hash: location.hash }} />;
}
